module.exports={name:"第5章 祈りの代償",number:5};